export default __webpack_public_path__ + "static/media/formas-digitales-fondo-banner-soporte-tecnico.0218bece.png";